<div class="row no-padding justify-content-center">
  <div class="col-10 side-nav-content">
    <div class="row justify-content-center">

      <!-- INFO -->
      <div class="col-12 margin-block-s">
        <a [href]="urlInform">
          <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
            <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/picto_information.svg"/>
            <span>{{ 'MENU.DECONNECTE.BOUTON1' | translate }}</span>
          </button>
        </a>
      </div>

      <!-- INSCRIPTION -->
      <div class="col-12 margin-block-s">
        <a [href]="urlRegister">
          <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
            <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Utilisateur.svg"/>
            <span>{{ 'MENU.DECONNECTE.BOUTON2' | translate }}</span>
          </button>
        </a>
      </div>

      <!-- CONNEXION -->
      <div class="col-12 margin-block-s">
        <a routerLink="/connexion" routerLinkActive="active">
          <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
            <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Deconnexion.svg"/>
            <span>{{ 'MENU.DECONNECTE.BOUTON3' | translate }}</span>
          </button>
        </a>
      </div>

      <!-- AIDE -->
      <div class="col-12 margin-block-s">
        <a [routerLink]="['/']" fragment="ccm">
          <button class="menu-btn titleBookkBorder" mat-stroked-button (click)="CloseAction();">
            <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_Aide.svg"/>
            <span>{{ 'MENU.DECONNECTE.BOUTON4' | translate }}</span>
          </button>
        </a>
      </div>

      <!-- FAQ -->
      <div class="col-12 margin-block-s">
        <a routerLink="/faq" routerLinkActive="active">
          <button class="menu-btn titleBookkBorder"  mat-stroked-button (click)="CloseAction();">
            <img *ngIf="site !== 'remi'" class="menu-icon-img" src="../../../assets/img/Pictos_Appli/Vert/SVG/Picto_FAQ.svg"/>
            <span>{{ 'MENU.DECONNECTE.BOUTON5' | translate }}</span>
          </button>
        </a>
      </div>

      <!-- LOGO CLEM -->
      <div *ngIf="buton_celm === true && site !== 'remi'" class="col-12 margin-block-s">
        <a href="https://www.clem-e.com/">
          <button class="col-12 titleBookkBorder" mat-stroked-button color="" (click)="CloseAction();" 
          style="text-align: left;height: 50px;font-size: 17px;"> <img height="25px;"
           style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Vert/SVG/picto_clem1.svg"/>
           </button>
        </a>
      </div>

    </div>
  </div>

  <!-- FOOTER -->
  <div class="col-12 user-info align-self-end mt-2">

    <!-- EMAIL -->
    <h4 class="d-flex justify-content-center align-items-center mt-3">
          <mat-icon *ngIf="site !== 'remi'">email</mat-icon>
          <a class="ml-2" href="https://www.clem-e.com/contactusager">{{ 'MENU.DECONNECTE.BOUTON11' | translate }}</a>
      </h4>

    <!-- PHONE DEFAULT -->
    <h5 *ngIf="site === 'default'" class="d-flex justify-content-center align-items-center">
      <mat-icon>phone</mat-icon>
      <span class="ml-2">+331 86 86 85 85</span>
    </h5>

    <!-- PHONE MAM -->
    <h5 *ngIf="site === 'mam'" class="d-flex justify-content-center align-items-center">
      <mat-icon>phone</mat-icon>
      <span class="ml-2">+33 4 15 85 95 72</span>
    </h5>

      <!-- PHONE Remi -->
      <h5 *ngIf="site === 'remi'" class="d-flex justify-content-center">
          +33(0) 806 70 33 33
      </h5>



       

    <!-- LANG -->
    <div class="d-flex justify-content-center mt-2">
      <select #langSelect (change)="translate.use(langSelect.value)">
        <option *ngFor="let lang of locales"
                [value]="lang.value"
                [selected]="lang.value === translate.currentLang">
          {{ lang.label }}
        </option>
      </select>
    </div>

  </div>
</div>